import { createSelector } from 'reselect';
import { path, prop, pathOr, filter } from 'ramda';

import { getPatientPageUrlId } from 'store/selectors/router';

import moment from 'moment';
import { FORM_NAMES } from 'constants/forms';
import { CURRENT } from 'constants/observationStatuses';

import { TECHNICIAN, SUPER_TECHNICIAN } from 'constants/userRoles';

import i18n from 'services/i18n';

const newReportState = prop('newReport');
const patientState = prop('patientsData');

export const getPractitionerListByPatient = createSelector(
  patientState,
  getPatientPageUrlId,
  (patientData, patientId) => path([patientId, 'data', 'generalPractitioner'], patientData),
);

export const getReportPdfFile = createSelector(
  newReportState,
  prop('pdfBase64'),
);

export const getReportCoding = createSelector(
  pathOr({}, ['form', FORM_NAMES.uploadCardioReport, 'values']),
  prop('type'),
);

export const getReportDate = createSelector(
  pathOr({}, ['form', FORM_NAMES.uploadCardioReport, 'values']),
  prop('reportDate'),
);

export const getPractitioners = createSelector(
  getPractitionerListByPatient,
  practitioners =>
    filter(
      ({ identifier: { value } = {} }) => value !== TECHNICIAN && value !== SUPER_TECHNICIAN,
      practitioners,
    ),
);

export const getCreatedCardioReportData = createSelector(
  getReportPdfFile,
  getPatientPageUrlId,
  getReportCoding,
  getReportDate,
  getPractitioners,
  (pdfBase64, patientId, coding, reportDate, practitioners) => {
    return {
      resourceType: 'DocumentReference',
      status: CURRENT,
      indexed: moment().toISOString(),
      type: {
        coding: [
          {
            code: coding,
            display: i18n.t(`cardiovascularInvestigations.${coding}`),
          },
        ],
      },
      subject: {
        reference: `Patient/${patientId}`,
      },
      extension: [
        {
          url: 'reportDate',
          valueDateTime: reportDate,
        },
      ],
      author: practitioners,
      content: [
        {
          attachment: {
            contentType: 'pdf',
            data: pdfBase64.replace(/^data:(.*;base64,)?/, ''),
          },
        },
      ],
    };
  },
);
